<template>
  <div class="guarantor-new">
    <div class="gua-form-step-container">
      <div class="form-scroller">
        <vue-scroll>
        <Form ref="newForm"
          :model="stepModel"
          :rules="modelValidate"
          label-position="right"
          :label-width="120">
          <div class="padding-top-20"></div>
          <Divider orientation="left">区域与行业</Divider>
          <Row :gutter="16">
            <Col :md="24" :lg="12">
              <FormItem label="所在区域" prop="cityId" style="width:100%">
                <Cascader v-model="stepModel.cities" :data="puyangCities" @on-change="citySelected" placeholder="选择"></Cascader>
              </FormItem>
            </Col>
            <Col :md="24" :lg="12">
              <FormItem label="行业/领域" prop="industryId" style="width:100%">
                <Select v-model="stepModel.industryId" filterable placeholder="选择专属行业/领域" @on-change="industrySelected">
                  <Option v-for="item in industries" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <div class="padding-top-20"></div>
          <Divider orientation="left">项目信息</Divider>
          <Row :gutter="16">
            <Col span="12">
              <FormItem label="项目名称" prop="project.name">
                <Input
                  v-model="stepModel.project.name"
                  search
                  enter-button
                  @on-search="searchProjects"
                  placeholder="输入项目名称关键字搜索"
                  @on-change="handleProjectInputChange" />
                <div class="search-result-list" v-if="projects.length && showProjectResults">
                  <div class="search-result-item" v-for="prj in projects" :key="prj.id" @click="selectProjectFromList(prj)">
                    {{prj.name}}
                  </div>
                </div>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="工程造价(元)" prop="project.cost">
                <InputNumber :min="0" :step="10000"
                  style="width: 100%"
                  v-model="stepModel.project.cost"
                  placeholder="输入工程造价(元)"></InputNumber>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="建设规模" prop="project.area">
                <InputNumber :min="0" :step="10000" style="width: 100%" v-model="stepModel.project.area" placeholder="输入建设规模(m/m²/m³)"></InputNumber>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="开竣工日期" prop="project.daterange">
                <DatePicker v-model="stepModel.project.daterange"
                  @on-change="prjDateChange"
                  type="daterange"
                  placement="bottom-end"
                  format="yyyy/MM/dd"
                  placeholder="选择开竣工日期"
                  style="width: 100%"></DatePicker>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="项目立项备案号" prop="project.filingNo">
                <Input v-model="stepModel.project.filingNo" placeholder="输入项目立项备案号" />
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="规划许可证号" prop="project.planLicenseNo">
                <Input v-model="stepModel.project.planLicenseNo" placeholder="输入规划许可证号" />
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="施工许可证号" prop="project.constrLicenceNo">
                <Input v-model="stepModel.project.constrLicenceNo" placeholder="输入施工许可证号" />
              </FormItem>
            </Col>
          </Row>
          <div class="padding-top-20"></div>
          <Divider orientation="left">业主信息</Divider>
          <Row :gutter="16">
            <Col :md="24" :lg="12" :xl="8" :xxl="6">
              <FormItem label="业主名称" prop="owner.name">
                <Input
                  v-model="stepModel.owner.name"
                  search
                  enter-button
                  @on-search="searchOwners"
                  placeholder="输入业主名称关键字搜索"
                  @on-change="handleOwnerInputChange" />
                <div class="search-result-list" v-if="owners.length && showOwnerResults">
                  <div class="search-result-item" v-for="own in owners" :key="own.tid" @click="selectOwnerFromList(own)">
                    {{own.name}}
                  </div>
                </div>
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8" :xxl="6">
              <FormItem label="社会信用代码" prop="owner.businessLicense">
                <Input v-model="stepModel.owner.businessLicense" placeholder="输入社会信用代码" />
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8" :xxl="6">
              <FormItem label="联系人" prop="owner.contact">
                <Input v-model="stepModel.owner.contact" placeholder="输入联系人" />
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8" :xxl="6">
              <FormItem label="联系电话" prop="owner.contactTel">
                <Input v-model="stepModel.owner.contactTel" placeholder="输入联系电话" />
              </FormItem>
            </Col>
          </Row>
          <div class="padding-top-20"></div>
          <Divider orientation="left">总承包信息</Divider>
          <Row :gutter="16">
            <Col :md="24" :lg="12" :xl="8" :xxl="6">
              <FormItem label="总承包商名称" prop="contractor.name">
                <Input
                  v-model="stepModel.contractor.name"
                  search
                  enter-button
                  @on-search="searchContractors"
                  placeholder="输入承包商名称关键字搜索"
                  @on-change="handleContractorInputChange" />
                <div class="search-result-list" v-if="contractors.length && showContractorResults">
                  <div class="search-result-item" v-for="con in contractors" :key="con.tid" @click="selectContractorFromList(con)">
                    {{con.name}}
                  </div>
                </div>
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8" :xxl="6">
              <FormItem label="社会信用代码" prop="contractor.businessLicense">
                <Input v-model="stepModel.contractor.businessLicense" placeholder="输入社会信用代码" />
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8" :xxl="6">
              <FormItem label="联系人" prop="contractor.contact">
                <Input v-model="stepModel.contractor.contact" placeholder="输入联系人" />
              </FormItem>
            </Col>
            <Col :md="24" :lg="12" :xl="8" :xxl="6">
              <FormItem label="联系电话" prop="contractor.contactTel">
                <Input v-model="stepModel.contractor.contactTel" placeholder="输入联系电话" />
              </FormItem>
            </Col>
          </Row>
        </Form>
        </vue-scroll>
      </div>
      <div class="bottom-buttons">
        <Row :gutter="16">
          <Col span="16" offset="4"><Button type="primary" size="large" long @click="submit">下一步</Button></Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'guarantor-new-puyang-step1',
  props: {
    data: Object
  },
  data () {
    return {
      loading: false,
      stepModel: {
        cityId: null,
        cities: [],
        industryId: null,
        industryName: null,
        project: {
          id: null,
          name: null,
          filingNo: null,
          planLicenseNo: null,
          constrLicenceNo: null,
          area: null,
          cost: null,
          startdate: null,
          finishdate: null,
          daterange: null
        },
        owner: {
          tid: null,
          name: null,
          businessLicense: null,
          contact: null,
          contactTel: null
        },
        contractor: {
          tid: null,
          name: null,
          businessLicense: null,
          contact: null,
          contactTel: null
        }
      },
      modelValidate: {
        'project.name': [
          { required: true, message: '请填写项目名称', trigger: 'blur' }
        ],
        'project.cost': [
          { required: true, type: 'number', message: '请填写工程造价', trigger: 'blur' }
        ],
        cityId: [
          { required: true, type: 'number', message: '请选择区域', trigger: 'change' }
        ],
        industryId: [
          { required: true, type: 'number', message: '请选择行业', trigger: 'change' }
        ],
        'owner.name': [
          { required: true, message: '请填写业主名称', trigger: 'blur' }
        ],
        'contractor.name': [
          { required: true, message: '请填写总承包商名称', trigger: 'blur' }
        ]
      },
      cities: [],
      industries: [],
      industryRecords: [],
      projects: [],
      owners: [],
      contractors: [],
      puyangCities: [],
      permittedCities: [],
      puyangRootCityId: null,
      // Track original data for change detection
      originalProject: null,
      originalOwner: null,
      originalContractor: null,
      projectModified: false,
      ownerModified: false,
      contractorModified: false,
      // Search result visibility
      showProjectResults: false,
      showOwnerResults: false,
      showContractorResults: false
    }
  },
  watch: {
  },
  mounted () {
    console.log('step1 mounted, data:', this.data)
    this.initCityAndIndustry()
    // Add click outside listener to close search results
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside (e) {
      // Check if click is outside the search result lists and input
      if (!e.target.closest('.search-result-list') && !e.target.closest('input')) {
        this.showProjectResults = false
        this.showOwnerResults = false
        this.showContractorResults = false
      }
    },
    prefillFromData () {
      console.log('prefill')
      if (!this.data) return
      // Prefill city selection (Cascader needs full path)
      if (this.data.cityId) {
        this.stepModel.cityId = this.data.cityId
        // Build Cascader path from city tree
        let cityPath = this.findCityPath(this.data.cityId)
        this.stepModel.cities = cityPath
      }
      // Prefill industry
      if (this.data.industryId) {
        this.stepModel.industryId = this.data.industryId
      }
      // Prefill project info
      if (this.data.project) {
        this.stepModel.project = { ...this.stepModel.project, ...this.data.project }
        // Convert project cost from cents to yuan
        if (this.stepModel.project.cost) {
          this.stepModel.project.cost /= 100
        }
        if (this.stepModel.project.daterange && !(this.stepModel.project.daterange instanceof Array)) {
          let daterange = []
          if (this.data.project.prjStartDate) daterange.push(new Date(this.data.project.prjStartDate))
          if (this.data.project.prjEndDate) daterange.push(new Date(this.data.project.prjEndDate))
          if (daterange.length === 2) this.stepModel.project.daterange = daterange
        }
      }
      // Prefill owner info
      if (this.data.owner) {
        this.stepModel.owner = { ...this.stepModel.owner, ...this.data.owner }
      }
      // Prefill contractor info
      if (this.data.contractor) {
        this.stepModel.contractor = { ...this.stepModel.contractor, ...this.data.contractor }
      }
      // Prefill supervisory info
      if (this.data.supervisory) {
        this.stepModel.supervisory = { ...this.stepModel.supervisory, ...this.data.supervisory }
      }
      console.log(this.stepModel)
    },
    findCityPath (cityId) {
      // Find the path from Puyang root to the selected city
      if (!this.puyangCities || !this.puyangCities.length) {
        return [cityId]
      }
      let puyangRoot = this.puyangCities[0]
      if (!puyangRoot) {
        return [cityId]
      }
      // If cityId is Puyang root itself
      if (puyangRoot.value === cityId) {
        return [cityId]
      }
      // Check if cityId is a direct child of Puyang root
      if (puyangRoot.children && puyangRoot.children.length) {
        let directChild = puyangRoot.children.find(c => c.value === cityId)
        if (directChild) {
          return [puyangRoot.value, cityId]
        }
      }
      // Return as-is if can't find matching structure
      return [cityId]
    },
    async initCityAndIndustry () {
      try {
        // Step 1: Get permitted cities for current guarantor
        let permittedRes = await Api.Guarantor.getMyPermittedCities()
        this.permittedCities = permittedRes.map(c => c.cityId)

        // Step 2: Find Puyang root city by name
        let puyangRoot = await this.findCityByName('濮阳市')
        if (!puyangRoot) {
          this.$Message.error('未找到濮阳市')
          return
        }
        this.puyangRootCityId = puyangRoot.tid

        // Step 3: Get Puyang's children (districts/counties)
        let childrenRes = await Api.City.listCities({
          tier: null,
          parentId: this.puyangRootCityId,
          isVisible: null
        }, 1, 1000)

        this.puyangCities = [{
          value: puyangRoot.tid,
          label: puyangRoot.name,
          children: childrenRes.data.map(c => ({
            value: c.tid,
            label: c.name
          }))
        }]

        // Default to Puyang city only if not already selected (for returning from step2)
        if (!this.stepModel.cityId) {
          this.stepModel.cityId = puyangRoot.tid
          this.stepModel.cities = [puyangRoot.tid]
        }

        // Load industries
        this.initIndustrySelect()

        // Prefill data after cities are loaded (for returning from step2)
        this.prefillFromData()
      } catch (err) {
        this.$Message.error('初始化城市信息失败!' + err.message)
      }
    },
    async findCityByName (name) {
      let res = await Api.City.listCities({
        name: name,
        tier: null,
        parentId: null,
        isVisible: null
      }, 1, 10)
      if (res.data && res.data.length > 0) {
        return res.data.find(c => c.name === name)
      }
      return null
    },
    initIndustrySelect () {
      let cityId = this.stepModel.cityId
      Api.Guarantor.getMyPermittedIndustries(cityId).then((res) => {
        let data = res.map((c) => {
          return {
            id: c.industryId,
            value: c.industryId,
            label: c.industryName
          }
        })
        this.industryRecords = res
        this.industries = data
        // Auto-select if only one industry
        if (res.length === 1) {
          this.stepModel.industryId = res[0].industryId
          this.stepModel.industryName = res[0].industryName
        }
      }).catch(err => {
        this.$Message.error('获取行业列表失败!' + err.message)
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        let selectedCityId = val[val.length - 1]
        // Check if selected city is in permitted list
        if (!this.permittedCities.includes(selectedCityId)) {
          this.$Message.warning('您没有权限选择该区域，已清除选择')
          this.stepModel.cities = []
          this.stepModel.cityId = null
          return
        }
        this.stepModel.cityId = selectedCityId
      } else {
        this.stepModel.cityId = val
      }
      // Reload industries for selected city
      this.initIndustrySelect()
    },
    industrySelected (val) {
      let ind = this.industryRecords.find(i => i.industryId === val)
      if (ind) {
        this.stepModel.industryName = ind.industryName
      }
    },
    selectProject (prj) {
      if (prj.tag) {
        let selected = this.projects.find(o => o.id === prj.tag)
        if (selected) {
          this.stepModel.project.id = selected.id
          this.stepModel.project.cost = selected.cost / 100
          this.stepModel.project.filingNo = selected.filingNo
          this.stepModel.project.planLicenseNo = selected.planLicenseNo
          this.stepModel.project.constrLicenceNo = selected.constrLicenceNo
          this.stepModel.project.area = selected.area
          if (selected.startdate && selected.finishdate) {
            this.stepModel.project.daterange = [selected.startdate, selected.finishdate]
          }
          // Store original data for change detection
          this.originalProject = JSON.parse(JSON.stringify(this.stepModel.project))
          this.projectModified = false
        }
      }
    },
    selectProjectFromList (prj) {
      this.stepModel.project.id = prj.id
      this.stepModel.project.name = prj.name
      this.stepModel.project.cost = prj.cost ? prj.cost / 100 : null
      this.stepModel.project.filingNo = prj.filingNo
      this.stepModel.project.planLicenseNo = prj.planLicenseNo
      this.stepModel.project.constrLicenceNo = prj.constrLicenceNo
      this.stepModel.project.area = prj.area
      if (prj.startdate && prj.finishdate) {
        this.stepModel.project.daterange = [prj.startdate, prj.finishdate]
      }
      this.originalProject = JSON.parse(JSON.stringify(this.stepModel.project))
      this.projectModified = false
      this.showProjectResults = false
    },
    handleProjectInputChange () {
      if (this.originalProject && this.originalProject.name !== this.stepModel.project.name) {
        this.projectModified = true
      }
      let query = this.stepModel.project.name
      if (query && query.length >= 2) {
        this.searchProjects(query)
      }
    },
    searchProjects (query) {
      if (!this.stepModel.cityId) {
        this.$Message.warning('请先选择区域')
        return
      }
      if (!query) return
      Api.Project.searchProjects({
        name: query,
        cityId: this.stepModel.cityId
      }, 1, 1000).then((prjs) => {
        this.projects = prjs.data || []
        this.showProjectResults = true
      }).catch(err => {
        this.$Message.error('获取项目列表失败!' + err.message)
      })
    },
    queryProjectChange (val) {
      // Mark as modified when user types (not selecting from dropdown)
      if (this.originalProject && this.originalProject.name !== val) {
        this.projectModified = true
      }
    },
    prjDateChange (date) {
      if (date && date instanceof Array && date.length === 2) {
        this.stepModel.project.startdate = require('moment')(date[0]).format('YYYY-MM-DD')
        this.stepModel.project.finishdate = require('moment')(date[1]).format('YYYY-MM-DD')
      }
    },
    selectOwner (own) {
      if (own.tag) {
        let selected = this.owners.find(o => o.tid === own.tag)
        if (selected) {
          this.stepModel.owner.tid = selected.tid
          this.stepModel.owner.businessLicense = selected.businessLicense
          this.stepModel.owner.contact = selected.contact
          this.stepModel.owner.contactTel = selected.contactTel
          // Store original data for change detection
          this.originalOwner = JSON.parse(JSON.stringify(this.stepModel.owner))
          this.ownerModified = false
        }
      }
    },
    selectOwnerFromList (own) {
      this.stepModel.owner.tid = own.tid
      this.stepModel.owner.name = own.name
      this.stepModel.owner.businessLicense = own.businessLicense
      this.stepModel.owner.contact = own.contact
      this.stepModel.owner.contactTel = own.contactTel
      this.originalOwner = JSON.parse(JSON.stringify(this.stepModel.owner))
      this.ownerModified = false
      this.showOwnerResults = false
    },
    handleOwnerInputChange () {
      if (this.originalOwner && this.originalOwner.name !== this.stepModel.owner.name) {
        this.ownerModified = true
      }
      let query = this.stepModel.owner.name
      if (query && query.length >= 2) {
        this.searchOwners(query)
      }
    },
    onOwnerChange (val) {
      // Mark as modified when user types (not selecting from dropdown)
      if (this.originalOwner && this.originalOwner.name !== val) {
        this.ownerModified = true
      }
    },
    searchOwners (query) {
      if (!query) return
      Api.Company.listCompanies({
        isLocal: null,
        name: query,
        type: 4
      }, 1, 1000).then((companies) => {
        this.owners = companies.data || []
        this.showOwnerResults = true
      }).catch(err => {
        this.$Message.error('获取业主列表失败!' + err.message)
      })
    },
    selectContractor (company) {
      if (company.tag) {
        let selected = this.contractors.find(o => o.tid === company.tag)
        if (selected) {
          this.stepModel.contractor.tid = selected.tid
          this.stepModel.contractor.businessLicense = selected.businessLicense
          this.stepModel.contractor.contact = selected.contact
          this.stepModel.contractor.contactTel = selected.contactTel
          // Store original data for change detection
          this.originalContractor = JSON.parse(JSON.stringify(this.stepModel.contractor))
          this.contractorModified = false
        }
      }
    },
    selectContractorFromList (con) {
      this.stepModel.contractor.tid = con.tid
      this.stepModel.contractor.name = con.name
      this.stepModel.contractor.businessLicense = con.businessLicense
      this.stepModel.contractor.contact = con.contact
      this.stepModel.contractor.contactTel = con.contactTel
      this.originalContractor = JSON.parse(JSON.stringify(this.stepModel.contractor))
      this.contractorModified = false
      this.showContractorResults = false
    },
    handleContractorInputChange () {
      if (this.originalContractor && this.originalContractor.name !== this.stepModel.contractor.name) {
        this.contractorModified = true
      }
      let query = this.stepModel.contractor.name
      if (query && query.length >= 2) {
        this.searchContractors(query)
      }
    },
    onContractorChange (val) {
      // Mark as modified when user types (not selecting from dropdown)
      if (this.originalContractor && this.originalContractor.name !== val) {
        this.contractorModified = true
      }
    },
    searchContractors (query) {
      if (!query) return
      Api.Company.listCompanies({
        isLocal: null,
        name: query,
        type: 1
      }, 1, 1000).then((companies) => {
        this.contractors = companies.data || []
        this.showContractorResults = true
      }).catch(err => {
        this.$Message.error('获取承包商列表失败!' + err.message)
      })
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          try {
            // Check and update project if modified
            if (this.stepModel.project.id) {
              if (this.projectModified) {
                await this.updateProject()
              }
            } else {
              // Create new project
              await this.createProject()
            }
            // Check and update owner if modified
            if (this.stepModel.owner.tid) {
              if (this.ownerModified) {
                await this.updateOwner()
              }
            } else {
              // Create new owner
              await this.createOwner()
            }
            // Check and update contractor if modified
            if (this.stepModel.contractor.tid) {
              if (this.contractorModified) {
                await this.updateContractor()
              }
            } else {
              // Create new contractor
              await this.createContractor()
            }
            // Convert cost to cents and emit
            let model = JSON.parse(JSON.stringify(this.stepModel))
            model.project.cost = Math.round(model.project.cost * 100)
            this.$emit('finish-step1', model)
          } catch (err) {
            this.$Message.error('保存失败!' + err.message)
          }
        }
      })
    },
    async updateProject () {
      if (!this.stepModel.project.id) return
      let updateData = {
        id: this.stepModel.project.id,
        name: this.stepModel.project.name,
        filingNo: this.stepModel.project.filingNo,
        planLicenseNo: this.stepModel.project.planLicenseNo,
        constrLicenceNo: this.stepModel.project.constrLicenceNo,
        area: this.stepModel.project.area,
        cost: Math.round(this.stepModel.project.cost * 100),
        startdate: this.stepModel.project.startdate,
        finishdate: this.stepModel.project.finishdate,
        cityId: this.stepModel.cityId
      }
      await Api.Project.updateProject(updateData)
    },
    async createProject () {
      let res = await Api.Project.addProject({
        name: this.stepModel.project.name,
        cost: Math.round((this.stepModel.project.cost || 0) * 100),
        cityId: this.stepModel.cityId
      })
      this.stepModel.project.id = res
      this.$Message.success('项目创建成功')
    },
    async updateOwner () {
      if (!this.stepModel.owner.tid) return
      let updateData = {
        id: this.stepModel.owner.tid,
        name: this.stepModel.owner.name,
        businessLicense: this.stepModel.owner.businessLicense,
        contact: this.stepModel.owner.contact,
        contactTel: this.stepModel.owner.contactTel,
        type: 4
      }
      await Api.Company.updateCompany(updateData)
    },
    async createOwner () {
      let res = await Api.Company.addCompany({
        name: this.stepModel.owner.name,
        type: 4,
        businessLicense: this.stepModel.owner.businessLicense,
        contact: this.stepModel.owner.contact,
        contactTel: this.stepModel.owner.contactTel
      })
      this.stepModel.owner.tid = res
      this.$Message.success('业主创建成功')
    },
    async updateContractor () {
      if (!this.stepModel.contractor.tid) return
      let updateData = {
        id: this.stepModel.contractor.tid,
        name: this.stepModel.contractor.name,
        businessLicense: this.stepModel.contractor.businessLicense,
        contact: this.stepModel.contractor.contact,
        contactTel: this.stepModel.contractor.contactTel,
        type: 1
      }
      await Api.Company.updateCompany(updateData)
    },
    async createContractor () {
      let res = await Api.Company.addCompany({
        name: this.stepModel.contractor.name,
        type: 1,
        businessLicense: this.stepModel.contractor.businessLicense,
        contact: this.stepModel.contractor.contact,
        contactTel: this.stepModel.contractor.contactTel
      })
      this.stepModel.contractor.tid = res
      this.$Message.success('承包商创建成功')
    }
  }
}
</script>

<style lang="less" scoped>
.guarantor-new {
  position: relative;
  height: 100%;
}
.gua-form-step-container {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
  .form-scroller {
    flex: 1;
    overflow: auto;
  }
  .bottom-buttons {
  }
}
.search-result-list {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  z-index: 100;
  .search-result-item {
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
    &:hover {
      background: #f5f5f5;
    }
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>